import { Bubble, FileCard, Image, SystemMessage, ThinkingProcess, Typing, TypingBubble } from '@chatui/core';
import { RichText, Divider } from '@chatui/core';
import {marked} from 'marked';
// import React from 'react';

function renderMarkDown(text) {
    if (!text && text !== 0) return '';
    marked.setOptions({
      gfm: true,
      breaks: true,
    });
    
    const renderer = new marked.Renderer();
    renderer.link = function(href) {
      console.log(href);
      return `<a href="${href.href}" title="${href.title || ''}" target="_blank" rel="noopener noreferrer">${href.text}</a>`;
    };
    
    marked.use({ renderer });
    
    return marked.parse(text);
  }

function renderMessageContent(t, msg) {
    const { type, content } = msg;

    switch (type) {
      case 'topPadding':
          return(
              <div style={{"height": "1px"}}></div>
          )
      case 'typingBubble':

        return (
          <div className="typing-container">
            {content.thinking && <ThinkingProcess thinking={content.thinking} defaultExpanded={true} />}
            {content.isLoading?(<Typing className="loading-dot"/>):(null)}
            <TypingBubble
                content={content.text}
                options={{ step: [1, 4], interval: 40 }}
                isRichText={true}
                messageRender={renderMarkDown}/>
            </div>)
      case 'text':
        if (content.isRich){
          return (
            <>
              {content.thinking && <ThinkingProcess thinking={content.thinking} defaultExpanded={false} />}
              <Bubble>
                <RichText content={renderMarkDown(content.text)}/>
              </Bubble>
            </>
          )
        }
        else{
          return (
            <>
              {content.thinking && <ThinkingProcess thinking={content.thinking} defaultExpanded={false} />}
              <Bubble content={content.text}></Bubble>
            </>
          )
        }
      case 'image':
        return (
          <Image src={content.picUrl} width="200" height="200" alt="图片名" />
        )
      case 'document':
        return (
          <FileCard file={{name: content.name, size: content.size}}/>
        )
      case 'loading':
        return(
              <Typing/>
        )
      case 'system':
        return (
            <SystemMessage content={content.text}></SystemMessage>
        )
      case 'parsing':
        return (
            <Typing text={t('chat.parsingVoice', '正在解析语音...')}></Typing>
        )
      case 'divider':
        return (
            <Divider position={"right"}> all</Divider>
        )
    //   case 'popDraft':
    //       const desc = content.language==="zh_cn" 
    //         ? t('chat.popDraftDesc', 'AI已为您生成泡泡内容，可以直接发布或编辑后发布')
    //         : t('chat.popDraftDescEn', 'A Pop-up draft has been generated by AI, you can publish it directly or edit it before publishing');
    //       let image = ['/images/laziji.png', '/images/shuizhuyu.png'];
    //       let title = "title";
    //       let text = "text";

          // for (let i in content.fields){
          //     if (content.fields[i].type==="image"){
          //         image = content.fields[i].value;
          //     }
          //     if (content.fields[i].type==="text"){
          //         title = content.fields[i].value;
          //     }
          //     else if (content.fields[i].type==="textarea"){
          //         text = content.fields[i].value;
          //     }
          // }
        // return (
        //     <BaseDraftCard
        //         cardType={"POP-UP"}
        //         reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
        //         language={content.language}
        //         height={60}
        //         popDesc={desc}
        //         title={title}
        //         text={text}
        //         fields={content.fields}
        //         editable={true}
        //         popExtraInfo={{
        //             status: 'draft',
        //             statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft'),
        //             image: image,
        //         }}
        //         submit={({title, text, image, table, language})=>generatePopup(title, text, image, table, language)}
        //     />
        // )
    //   case 'popCard':
    //     return (
    //         <BaseDraftCard
    //             title={content.title}
    //             editable={false}
    //             text={content.text}
    //             language={content.language}
    //             popExtraInfo={{
    //                 statusText: content.language==="zh_cn" ? t('chat.released', '已发布') : t('chat.released', 'Released'),
    //                 image: content.image
    //             }}
    //             bottomInfo={[
    //                 {icon: "servicer-o", text: content.servicer},
    //                 {icon: "alarm", text: content.timeSpan},
    //                 {icon: "check", text: content.lookNum},
    //                 {icon: "thumbs-up", text: content.likeNum}
    //             ]}
    //         />
    //     )
    //   case 'operationCard':
    //     const operationItems = {
    //       [t('chat.menuManagement', '菜单管理')]: [
    //         { label: t('chat.addNewProducts', '添加新商品'), value: 'Add New Products' },
    //         { label: t('chat.removeProducts', '移除商品'), value: 'Remove Products' },
    //         { label: t('chat.changeProducts', '修改商品'), value: 'Change Products' }],
    //       [t('chat.storeManagement', '店铺管理')]:[
    //         { label: t('chat.changeStoreStatus', '更改店铺状态'), value: 'Change Store Status' },
    //         { label: t('chat.changeOpenHour', '更改营业时间'), value: 'Change Open Hour' },
    //       ]
    //     };

    //     return (
    //         // <OperationCard title={"运营操作选项"} text={"目前支持以下运营选项，点击选择。"} operationItems={operationItems}></OperationCard>
    //         <PromotionOptionsCard
    //             title={t('chat.operationsTitle', '我们支持以下运营操作：')}
    //             options={operationItems}
    //             onOptionClick={(text)=>setInputText(text)}
    //         ></PromotionOptionsCard>
    //     )

    //   case 'serviceTicket':
    //     return (
    //         <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={false}
    //             serviceTicketExtraInfo={{
    //                 level: content.level,
    //                 levelText: content.levelText,
    //                 trackingNumber: {text: (content.language==="zh_cn" ? t('chat.trackingNo', '工单号 WO-') : t('chat.trackingNo', 'Tracking No. WO-')) + Math.floor(Math.random() * 999999).toString().padStart(6, '0')},
    //                 status: content.status,
    //                 statusText: content.language==="zh_cn" ? t('chat.completed', '已完成') : t('chat.completed', 'Completed')
    //             }}
    //             bottomInfo={[
    //                 {icon:'servicer-o', text: 'Tangxiaoer'},
    //                 {icon:'alarm', text: getTimeSpan(content.time, content.language)},
    //             ]}
    //         />
    //     )
    //   case 'goodsEnlist':
    //     return(
    //         <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={true}
    //             serviceTicketExtraInfo={{
    //                 status: 'draft',
    //                 statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //             }}
    //             submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //         />
    //     )
    //   case 'goodsRemoval':
    //     return(
    //        <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={true}
    //             serviceTicketExtraInfo={{
    //                 status: 'draft',
    //                 statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //             }}
    //             submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //         />
    //     )
    //   case 'artificialPromotion':
    //     return (
    //         <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={true}
    //             serviceTicketExtraInfo={{
    //                 status: 'draft',
    //                 statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //             }}
    //             submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //         />
    //     )
    //     case 'registration':
    //         return (
    //             <BaseDraftCard
    //                 cardType={"ServiceTicket"}
    //                 reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //                 language={content.language}
    //                 title={content.title}
    //                 text={content.text}
    //                 fields={content.fields}
    //                 editable={true}
    //                 serviceTicketExtraInfo={{
    //                     status: 'draft',
    //                     statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //                 }}
    //                 submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //             />
    //         )
    //   case 'groupBuyingCard':
    //     return(
    //         <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={true}
    //             serviceTicketExtraInfo={{
    //                 status: 'draft',
    //                 statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //             }}
    //             submit={({title, text, table, language})=>{
    //                 return new Promise((resolve, reject) => {
    //                     // 使用Promise.all等待所有异步操作完成
    //                     Promise.all([
    //                         generateServiceTicket(title, text, table, language)
    //                             .catch(error => {
    //                                 console.error("Service ticket creation failed:", error);
    //                                 return { success: false, error };
    //                             }),
    //                         generatePopup(title, text, table["Image"], table, language)
    //                             .catch(error => {
    //                                 console.error("Popup creation failed:", error);
    //                                 return { success: false, error };
    //                             })
    //                     ]).then(([serviceTicketResult, popupResult]) => {
    //                         // 检查两个操作的结果
    //                         const errors = [];

    //                         if (!serviceTicketResult || serviceTicketResult.success === false) {
    //                             errors.push(i18n.language === 'zh' ? t('chat.failCreateServiceTicket', '创建团购工单失败') : t('chat.failCreateServiceTicket', 'Fail to create service ticket of group buying'));
    //                         }

    //                         if (!popupResult || popupResult.success === false) {
    //                             errors.push(i18n.language === 'zh' ? t('chat.failCreatePopup', '创建团购泡泡失败') : t('chat.failCreatePopup', 'Fail to create Pop-up of group buying'));
    //                         }

    //                         if (errors.length > 0) {
    //                             reject(errors.join("; "));
    //                         } else {
    //                             resolve();
    //                         }
    //                     }).catch(error => {
    //                         reject(i18n.language === 'zh' ? t('chat.unexpectedError', '意外错误：{{message}}', { message: error.message }) : t('chat.unexpectedError', 'Unexpected error: {{message}}', { message: error.message }));
    //                     });
    //                 });
    //             }}
    //         />
    //     )
    //   case 'menu':
    //     const items = content.items;
    //     return (
    //         <Menu
    //             title={t('chat.servicesTitle', '我支持以下服务：')}
    //             onItemClick={handleMenuClick}
    //             items={items}
    //         ></Menu>
    //     )
    //   case 'subsidyCard': // todo 考虑要不要分开
    //     return (
    //         <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={true}
    //             serviceTicketExtraInfo={{
    //                 status: 'draft',
    //                 statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //             }}
    //             submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //         />
    //     )
    //   case 'promotionOptionsCard':
    //     return (
    //         <PromotionOptionsCard
    //           title={t('chat.promotionWaysTitle', '我们支持以下促销方式：')}
    //           onOptionClick={(text)=>setInputText(text)}
    //         ></PromotionOptionsCard>
    //     )
    //   case 'advertiseOnPlatform':
    //     return(
    //         <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={true}
    //             serviceTicketExtraInfo={{
    //                 status: 'draft',
    //                 statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //             }}
    //             submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //         />
    //     )
    //   case 'inquiringCard':
    //       const servicesItems = [
    //           {label: t('chat.services.posPowerBank', 'POS、充电宝'), value: 'typingBubble', content: {text: t('chat.services.posPowerBank', 'POS、充电宝')}},
    //           {label: t('chat.services.advertisingPromotion', '广告与促销'), value: 'typingBubble', content: {text: t('chat.services.advertisingPromotion', '广告与促销')}},
    //           {label: t('chat.services.platformServices', '12POP平台有哪些服务？'), value: 'typingBubble', content: {text: t('chat.services.platformServices', '12POP平台有哪些服务？')}},
    //           {label: t('chat.services.logisticsServices', '物流服务'), value: 'typingBubble', content: {text: t('chat.services.logisticsServices', '物流服务')}},
    //       ];
    //     return (
    //         <Menu
    //             title={t('chat.servicesTitle', '我支持以下服务：')}
    //             onItemClick={handleMenuClick}
    //             items={servicesItems}
    //         ></Menu>
    //     )
    //   case 'inquiry':
    //     return(
    //          <TypingBubble
    //             content={content.fields}
    //             options={{ step: [1, 6], interval: 50 }}
    //             isRichText={true}
    //             messageRender={renderMarkDown}/>
    //     )
    //   case 'artificialServiceTicket':
    //       return(
    //           <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={true}
    //             serviceTicketExtraInfo={{
    //                 status: 'draft',
    //                 statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //             }}
    //             submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //         />
    //       )

    //   case 'setStoreStatus':
    //       return (
    //           <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={true}
    //             serviceTicketExtraInfo={{
    //                 status: 'draft',
    //                 statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //             }}
    //             submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //         />
    //       )
    //   case 'changeOpenHour':

    //       return (
    //         <BaseDraftCard
    //             cardType={"ServiceTicket"}
    //             reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //             language={content.language}
    //             title={content.title}
    //             text={content.text}
    //             fields={content.fields}
    //             editable={true}
    //             serviceTicketExtraInfo={{
    //                 status: 'draft',
    //                 statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //             }}
    //             submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //         />
    //       )
    //   case 'goodsChange': // todo 暂时没想好如何更改
    //       return(
    //           <GoodsChange
    //             language={content.language}
    //             status={content.status}
    //             statusList={content.statusList}
    //             onAcknowledge={(title, text, table, language)=>generateServiceTicket(title, text, table, language)}
    //           ></GoodsChange>
    //       )
    //     case 'transferToHuman':
    //         return(
    //             <SystemMessage
    //                 content={t('chat.contactingHumanService', '正在联系人工客服')}
    //                 action={{
    //                     text: t('chat.cancel', '取消'),
    //                     onClick: content.onCancel,
    //                     once: content.once
    //                 }}
    //             />
    //         )
    //     case 'logisticsCard':
    //         const logisticsItems = {
    //           [t('chat.arrangeRidersDrivers', '安排骑手/司机')]: [
    //             { label: t('chat.instantDelivery', '即时配送'), value: 'Instant Delivery' },
    //             { label: t('chat.arrangementForSeveralOrders', '多单安排'), value: 'Arrangement for Several Orders' }]
    //         };
    //         return (
    //             <PromotionOptionsCard
    //                 title={t('chat.operationsTitle', '我们支持以下运营操作：')}
    //                 options={logisticsItems}
    //                 onOptionClick={(text)=>setInputText(text)}
    //             ></PromotionOptionsCard>
    //         )
    //     case 'instantDelivery':
    //         return(
    //             <BaseDraftCard
    //                 cardType={"ServiceTicket"}
    //                 reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //                 language={content.language}
    //                 title={content.title}
    //                 text={content.text}
    //                 fields={content.fields}
    //                 editable={true}
    //                 serviceTicketExtraInfo={{
    //                     status: 'draft',
    //                     statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //                 }}
    //                 submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //             />
    //         )
    //     case 'arrange4MultipleOrders':

    //         return (
    //             <BaseDraftCard
    //                 cardType={"ServiceTicket"}
    //                 reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //                 language={content.language}
    //                 title={content.title}
    //                 text={content.text}
    //                 fields={content.fields}
    //                 editable={true}
    //                 serviceTicketExtraInfo={{
    //                     status: 'draft',
    //                     statusText: content.language==="zh_cn" ? t('chat.draft', '草稿') : t('chat.draft', 'Draft')
    //                 }}
    //                 submit={({title, text, table, language})=>generateServiceTicket(title, text, table, language)}
    //             />
    //         )
    //     case 'BaseDraftCard':
    //         const tmpFields = [
    //             {name: "整数", description: "说明文本说明文本说明文本说明文本说明文本说明文本说明文本说明文本", type: "int", value: 0, format: {maximum: 100, minimum: 0, editable: false}},
    //             {name: "文本", description: "说明文本", type: "text", value: ""},
    //             {name: "小数", description: "说明文本", type: "float", value: "5.2"},
    //             {name: "图片", description: "说明文本", type: "image", value: ['/images/laziji.png', '/images/shuizhuyu.png']},
    //             {name: "地址", description: "说明文本", type: "address", value: ""},
    //             {name: "日期", description: "说明文本说明文本说明文本说明文本说明文本说明文本说明文本说明文本说明文本说明文本", type: "date", value: "2025-10-17"},
    //             {name: "时间", description: "说明文本", type: "time", value: "17:35"},
    //             {name: "多行文本", description: "说明文本", type: "textarea", value: ""},
    //             {name: "订单", description: "说明文本", type: "order", value: ""},
    //             {name: "商品", description: "说明文本", type: "products", value: "", format: {currency: 'xx$'}},
    //             {name: "单选", description: "说明文本", type: "radio", value: "", format:{options: [{label: "满减", value: 0}, {label: "满赠", value: 1}]}},
    //             {name: "多选", description: "说明文本", type: "checkbox", value: [], format: {options: [{label: "小红书", value: 0}, {label: "谷歌", value: 1}]}},
    //             {name: "状态", description: "说明文本", type: "store-status", value: {"2025-11-26": 0}},
    //         ];
    //         return (
    //             <BaseDraftCard
    //                 // cardType={"POP-UP"}
    //                 cardType={"ServiceTicket"}
    //                 reviseTitle={content.language==="zh_cn" ? t('chat.review', '预览') : t('chat.review', 'Review')}
    //                 language={"en_us"}
    //                 title={"设置店铺状态 Base Card BaseCardBaseCardBaseCardBaseCard Base Card Base Card Base Card Base Card Base Card "}
    //                 text={" Card Text Card Text Card Text Card Text Card Text Card Text Card Text ard Text Card Text Card Text Card Text Card Text Card Text Card Text"}
    //                 fields={tmpFields}
    //                 editable={true}
    //                 serviceTicketExtraInfo={{
    //                     level: 'high',
    //                     levelText: '中',
    //                     trackingNumber: {text: (i18n.language === 'zh' ? t('chat.trackingNo', '工单号 WO-') : t('chat.trackingNo', 'Tracking No. WO-')) + Math.floor(Math.random() * 999999).toString().padStart(6, '0')},
    //                     status: 'progress',
    //                     statusText: "进行中 预计完成时间2025/11/11"
    //                 }}
    //                 popExtraInfo={{
    //                     statusText: "泡泡状态",

    //                 }}
    //                 bottomInfo={[
    //                     {icon:'servicer-o', text: 'Tangxiaoer'},
    //                     {icon:'check', text: 543},
    //                     {icon:'thumbs-up', text: 178},
    //                     {icon:'alarm', text: getTimeSpan("2025-11-20 18:00:00", "en_us")},
    //                 ]}
    //                 popDesc={"AI已为您生成泡泡内容"}
    //             ></BaseDraftCard>
    //         )
      default:
        return null
    }
  }

export default renderMessageContent;